import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "14",
  height: "12",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  d: "M7 2.792a2.918 2.918 0 0 1 2.917 2.916c0 .298-.059.584-.14.852l1.785 1.785a6.884 6.884 0 0 0 1.855-2.643 6.902 6.902 0 0 0-8.54-4.036l1.265 1.266c.275-.082.56-.14.858-.14ZM1.995.429l-.823.828 1.564 1.564A6.847 6.847 0 0 0 .583 5.708 6.899 6.899 0 0 0 7 10.083c.887 0 1.732-.175 2.514-.478l2.001 2 .822-.822L1.995.43ZM7 8.625a2.918 2.918 0 0 1-2.917-2.917c0-.449.105-.875.286-1.248l.916.916a2.003 2.003 0 0 0-.035.332c0 .969.782 1.75 1.75 1.75.117 0 .222-.017.332-.04l.916.915c-.379.187-.799.292-1.248.292Zm1.732-3.11a1.732 1.732 0 0 0-1.54-1.54l1.54 1.54Z",
  fill: "#fff"
}, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_3))
}
export default { render };